import { ILangObj } from '@/slices/goyoloSeo/sliceType';

export const renderDuration = (n: number): string => {
  if (!n) return '';
  const num = n;
  const hours = num / 60;
  const rhours = Math.floor(hours);
  const minutes = (hours - rhours) * 60;
  const rminutes = Math.round(minutes);
  const hoursStr = rhours > 0 ? `${rhours}h` : '';
  const minutesStr = rminutes > 0 ? `${rminutes}p` : '';
  return `${hoursStr}${minutesStr}`;
};

export const renderDurationSeo = (n: number, lang?: ILangObj): string => {
  if (!n) return `0 ${lang?.lang === 'en' ? 'minute' : 'phút'}`;
  const num = n;
  const hours = num / 60;
  const rhours = Math.floor(hours);
  const minutes = (hours - rhours) * 60;
  const rminutes = Math.round(minutes);
  const hour = rhours && rhours > 1 ? 'hours' : 'hour';
  const hoursStr = rhours > 0 ? `${rhours} ${lang?.lang === 'en' ? hour : 'tiếng'} ` : '';
  const minutesText = rminutes && rminutes > 1 ? 'minutes' : 'minute';

  const minutesStr = rminutes > 0 ? `${rminutes} ${lang?.lang === 'en' ? minutesText : 'phút'}` : `0 ${lang?.lang === 'en' ? 'minute' : 'phút'}`;
  return `${hoursStr}${minutesStr}`;
};
